import styled from "styled-components";

export const CardSms = styled.div`
    background: rgb(252, 0, 5, 30%);
    padding: 5px;
    border-radius: 5px;
    text-align: center;
`;